<template>
  <div>
    <el-dialog append-to-body top="50px" :title="`命中配置查询`" :visible.sync="dialogVisible" width="50%"
      :before-close="handleClose">
      <el-form ref="form" :model="formChild" label-width="120px" style="padding: 0 50px;" :rules="rules">
        <el-form-item label="配置类型" prop="appType">
          <el-radio-group v-model="formChild.appType">
            <el-radio label="1">渠道</el-radio>
            <el-radio label="2">平台</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="appidFilterNames" label="渠道(appID)" v-if="formChild.appType == 1">
          <DynamicOption style="width:200px;" :singleSelect="true" v-model="formChild.channelId" />
        </el-form-item>
        <div v-if="formChild.appType == 2">

          <el-form-item label="定制类型" prop="customizedType">
            <el-radio-group v-model="formChild.customizedType">
              <el-radio label="1">SDK</el-radio>
              <el-radio label="2">APP</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="终端类型" prop="terminalType">
            <el-radio-group v-model="formChild.terminalType">
              <el-radio label="1">发送端</el-radio>
              <el-radio label="2">接收端</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="发端类型" prop="platform">
            <el-radio-group v-model="formChild.platform" :disabled="formChild.terminalType == 2">
              <el-radio label="Android">Android</el-radio>
              <el-radio label="IOS">IOS</el-radio>
              <el-radio label="Windows">Windows</el-radio>
              <el-radio label="MAC">MAC</el-radio>
              <el-radio label="web">web</el-radio>
              <el-radio label="weixin">微信小程序</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="收端类型" prop="platform">
            <el-radio-group v-model="formChild.platform" :disabled="formChild.terminalType == 1">
              <el-radio label="Android">Android（TV）</el-radio>
              <el-radio label="Windows">Windows</el-radio>
              <el-radio label="MAC">MAC</el-radio>
              <el-radio label="Linux">Linux</el-radio>
              <el-radio label="cloudApp">云应用</el-radio>
            </el-radio-group>
          </el-form-item>

        </div>

        <el-form-item label="厂商" prop="manufacturer">
          <el-input v-model="formChild.manufacturer"></el-input>
        </el-form-item>

        <el-form-item label="品牌" prop="brand">
          <el-input v-model="formChild.brand"></el-input>
        </el-form-item>

        <el-form-item label="型号" prop="model">
          <el-input v-model="formChild.model"></el-input>
        </el-form-item>

        <el-form-item label="uid" prop="uid">
          <el-input v-model="formChild.uid"></el-input>
        </el-form-item>

        <el-form-item label="用户ID（uuid）" prop="uuid">
          <el-input v-model="formChild.uuid"></el-input>
        </el-form-item>

        <el-form-item label="应用版本" prop="appVersion">
          <el-input v-model="formChild.appVersion"></el-input>
        </el-form-item>

        <el-form-item label="SDK版本" prop="sdkVersion">
          <el-input v-model="formChild.sdkVersion"></el-input>
        </el-form-item>

      </el-form>

      <div class="dialog-footer">
        <el-button @click="$emit('input', false)">取 消</el-button>
        <el-button type="primary" @click="configCommonSave">发起查询</el-button>
      </div>

      <el-input type="textarea" v-loading="loading" :rows="15" placeholder="响应结果" v-model="formChild.value">
      </el-input>

    </el-dialog>

  </div>
</template>

<script>

import { configCommonHitApi } from '@/api/channelSdkConfig.js'

import DynamicOption from '@/components/DynamicOption/index.vue'
export default {
  components: {
    DynamicOption
  },
  props: {
    value: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      loading: false,
      formChild: {
        appType: '2',
        customizedType: '2',
        terminalType: '1',
      },

    };
  },
  computed: {
    dialogVisible() {
      return this.value
    },
    rules() {
      let rulesData = {

        appType: [
          { required: true, message: '配置类型', trigger: 'change' }
        ]

      }


      this.$nextTick(() => {
        this.$refs['form'] && this.$refs['form'].clearValidate()
      })
      return rulesData
    }
  },


  methods: {

    // 保存
    configCommonSave() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          configCommonHitApi(this.formChild).then(res => {
            console.log('configCommonHitApi+++++++++', res)
            this.loading = false
            if (res.data.code == 200) {

              this.formChild.value = JSON.stringify(JSON.parse(res.data.data), null, '\t')
            }
          })
          console.log(valid)


        }
      });



    },

    handleClose() {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$emit('input', false)
        })
        .catch(_ => { });
    }
  }
};
</script>
<style scoped lang="scss" >
.dialog-footer {
  text-align: center;
  padding: 10px 0 20px;
}
</style>